export const iconFontAwesomeUsersPeopleAccessibleIcon = (
	<i className="fa-solid fa-accessible-icon"></i>
);
